import { directive } from 'vue-clickaway';

export default directive;
